module.exports = __webpack_public_path__ + "static/about-insta-3-cdf6f4422dc8ed20087b89d6bbd31c66.jpg";